/* SVADEZI — full variant matrix, shared by the PDP scripts.

   THE PROBLEM
   product.variants is capped at 250 entries — by Liquid, and by the
   /products/<handle>.js endpoint too. The ring products carry
   12 metals x 2 stones x 17 sizes = 408 variants, so 158 of them are invisible
   to any code reading product.variants. Measured on svadezi-gr-8951-p12:
   __pdpVariants exposed 8 of 12 metal values (7 x 34 + 12 = exactly 250) — no
   925 Silver at all, and no 9 KT Yellow Gold.

   Consequences before this shim:
     · the variant sync missed, hit `if (!match) return;` and SILENTLY kept the
       previously selected variant — the customer saw 925 selected while the
       cart still held the 18 KT item at the 18 KT price.
     · pdp-breakdown.js variant() returned null, compute() bailed, and the
       price / grams / breakdown stayed on the previous selection.

   THE SOURCE OF TRUTH
   custom.variant_pricing carries the FULL matrix (408 rows here, verified) as
       [variantId, oldPrice, oldCompareAt, grams]
   keyed by the variant title with ' / ' swapped for '|', which is exactly
   options.join('|'). Note the ring size VALUE itself contains ' | '
   ("IND 5  |  US 2  |  44.8 mm"), so a key can never be reliably SPLIT back
   into options — only constructed. Everything here constructs.

   row[1] is the PRE-repricing price and must not be shown; the displayed price
   is the formula price from pdp-breakdown.js. This module is only used to
   recover the variant ID and to test whether a combination exists at all.

   WHERE THE BLOB LIVES — the subtle bit
   #pdp-bd-data is emitted inside <template id="pdp-bd-tpl">, and a template's
   contents are an inert DocumentFragment: document.getElementById cannot see
   them. It only appears in the document once pdp-breakdown.js clones the
   template, which runs AFTER this file. So look in the live DOM first, then in
   the template fragment (querySelector — a fragment has no getElementById),
   and cache ONLY on success so an early call cannot poison the cache with null. */
(function () {
  var cache = null;

  function readBlob() {
    var el = document.getElementById('pdp-bd-data');
    if (!el) {
      var tpl = document.getElementById('pdp-bd-tpl');
      if (tpl && tpl.content) el = tpl.content.querySelector('#pdp-bd-data');
    }
    return el;
  }

  function matrix() {
    if (cache) return cache;            // only a SUCCESSFUL read is cached
    try {
      var el = readBlob();
      if (el) {
        var vp = (JSON.parse(el.textContent) || {}).variantPricing;
        if (vp && Object.keys(vp).length) cache = vp;
      }
    } catch (e) { /* leave uncached and retry on the next call */ }
    return cache;
  }

  function row(values) {
    var m = matrix();
    if (!m) return null;
    if (!values || values.some(function (v) { return v === null || v === undefined; })) return null;
    return m[values.join('|')] || null;
  }

  window.SvadeziVariants = {
    available: function () { return !!matrix(); },
    size: function () { var m = matrix(); return m ? Object.keys(m).length : 0; },
    row: row,
    id: function (values) { var r = row(values); return r && r[0] ? r[0] : null; },
    grams: function (values) { var r = row(values); return r && r[3] ? Number(r[3]) : null; },
    exists: function (values) { return !!row(values); }
  };
})();
